import React from  'react';
import Auth from '../services/auth';

const  base_url = process.env.REACT_APP_API_URL;

const PostRequest = async(data,endPoint)=>{
    var auth_token = await Auth.GetToken();
    return fetch(base_url+endPoint, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials : 'include',
        headers: new Headers ({
         'Content-type':'application/json',
         "Authorization": "Token " + auth_token
        }),
    })
    .then((response) => response.json())
    .then((responseJson) => {
     return(responseJson);
    })
    .catch((error) => {
        console.error('API PostRequest Error:', error);
        return { status: 500, error: true };
    })
};


const PostRequestForm=async (data, endPoint)=>{
  var auth_token =  await Auth.GetToken();
  return fetch(base_url+endPoint, {
    method: 'POST',
    body: data,
    credentials : 'include',
    headers : new Headers({
      "Authorization": "Token " + auth_token
    }),
    })
    .then((response) => response.json())
    .then((responseJson) => {
      return(responseJson);
    })
    .catch((error)=>{
      console.error('API PostRequestForm Error:', error);
      return { status: 500, error: true };
    });   
};



const GetRequest=async (params, endPoint)=>{

    var url = base_url + endPoint

    if(Object.keys(params).length > 0){
      url =  url + '?' + new URLSearchParams(params)
    }
    var auth_token =  await Auth.GetToken();
    return fetch(url, {
      method: 'GET',
      credentials : 'include',
      headers : new Headers({
          'Content-Type':'application/json',
          "Authorization": "Token " + auth_token
        }),
    })
    .then((response) => response.json())
    .then((responseJson) => {
      return(responseJson);
    })
    .catch((error)=>{
      console.error('API GetRequest Error:', error);
      return { status: 500, error: true };
    });   
};


const GetUserInfo=async (token)=>{
  console.log(token)
  var url = "https://www.googleapis.com/oauth2/v1/userinfo"
  return fetch(url, {
    method: 'GET',
    headers : new Headers({
        'Authorization' : 'Bearer '+token
      }),
  })
  .then((response) => response.json())
  .then((responseJson) => {
    return(responseJson);
  })
  .catch((error)=>{
    alert("Something went wrong. please try again later.");
  });   
};




export default { PostRequest, PostRequestForm, GetRequest, GetUserInfo };